import type Lenis from "lenis";

/**
 * Longer + gentler than the site-wide Lenis default (1.2s, expo-out): a CTA
 * jumping several screens down a page reads as a "jump" at the default pace,
 * so in-page anchor clicks get their own slower, more eased scroll.
 *
 * ease-in-out (rather than ease-out) so the motion ramps up gently instead of
 * moving fastest right at the start, which is what read as "too fast" even
 * with a longer duration.
 */
const ANCHOR_SCROLL_DURATION = 2.2;
const ANCHOR_SCROLL_EASING = (t: number): number =>
  t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

/**
 * Smooth-scrolls to an in-page hash (e.g. "#pricing"). Routes through the
 * shared Lenis instance when it's mounted; falls back to the native smooth
 * scroll so the click still works before Lenis's dynamic import resolves or
 * when the visitor has reduced-motion enabled.
 */
export const scrollToHash = (lenis: Lenis | null, hash: string): void => {
  if (lenis) {
    lenis.scrollTo(hash, {
      duration: ANCHOR_SCROLL_DURATION,
      easing: ANCHOR_SCROLL_EASING,
    });
    return;
  }

  document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
};
